import { add } from "@sinch/utils/dateTime/dateFns";
import { DurationUnitFormat } from "@sinch/utils/durationUnitFormat/DurationUnitFormat";
import { includes, values } from "ramda";
import { IntlShape, useIntl } from "react-intl";
import { ExpandedFormats } from "@sinch/core/hooks/format.types";

export const useFormatDuration = () => {
  const { formatNumber, formats, locale } = useIntl() as IntlShape & {
    formats: ExpandedFormats;
  };
  return (value: number, { format }: { format?: keyof ExpandedFormats["duration"] }) => {
    const options = format ? { useFloat: false, ...formats.duration[format] } : undefined;
    const durationFormat = new DurationUnitFormat(locale.toLowerCase(), options);
    if (options?.useFloat) {
      // This hack can create duration with float values, eg. 1.5 hours
      return durationFormat
        .formatToParts(value)
        .map(({ type, value: partVal }) => {
          if (includes(type, values(DurationUnitFormat.units))) {
            const secondsInUnit = add(new Date(0), { [`${type}s`]: 1 }).getTime() / 1000;
            return formatNumber(value / secondsInUnit);
          }
          return partVal;
        })
        .join("");
    } else {
      return durationFormat.format(value);
    }
  };
};
